import { authorizationService } from '.';
import { authorizationConstants } from '../components';
import { store } from './';
import { commentPositionalSort } from './commentPositionalSort';

export const commentHelper = {
    canDelete,
    sortPositionally,
    sortByTime,
    showEdit,
    canModifyAnnotation
};

function canDelete(createdById) {
    const state = store.getState();
    const { authentication } = state;
    var userId = authentication.user.authData.id;

    let isUserPermittedToDelete = authorizationService.isUserPermitted(
        authorizationConstants.ProofEditor.KEY,
        authorizationConstants.ProofEditor.ACTION_PROOF_EDITOR_COMMENT_DELETE
    );

    let isUserPermittedToDeleteAny = authorizationService.isUserPermitted(
        authorizationConstants.ProofEditor.KEY,
        authorizationConstants.ProofEditor.ACTION_PROOF_EDITOR_COMMENT_DELETE_ANY
    );

    var canDelete = isUserPermittedToDeleteAny
        ? true
        : isUserPermittedToDelete && userId === createdById
        ? true
        : false;

    return canDelete;
}

function canModifyAnnotation(createdById) {
    const state = store.getState();
    const { authentication } = state;
    var userId = authentication.user.authData.id;
    
    let isUserPermittedToModifyAny = authorizationService.isUserPermitted(
        authorizationConstants.ProofEditor.KEY,
        authorizationConstants.ProofEditor.ACTION_PROOF_EDITOR_ANNOTATION_MODIFY_ANY
    );

    

    var canModify = isUserPermittedToModifyAny
        ? true
        : userId === createdById
        ? true
        : false;

    return canModify;
}

function showEdit(createdById) {
    const state = store.getState();
    const { authentication } = state;
    var userId = authentication.user.authData.id;

    
    return userId === createdById;
}

function getCreatedAtTime(item) {
    var createdAt = item?.annotations?.[0]?.createdAt;
    var time = new Date(createdAt).getTime();
    return Number.isFinite(time) ? time : 0;
}

function sortByTime(items) {
    var decoratedItems = items.map(function (item) {
        return {
            item: item,
            time: getCreatedAtTime(item)
        };
    });

    decoratedItems.sort(function (a, b) {
        return a.time - b.time;
    });

    for (var i = 0; i < decoratedItems.length; i++) {
        items[i] = decoratedItems[i].item;
    }

    return items;
}

function sortPositionally(items, options = {}) {
    return commentPositionalSort.sortPositionally(items, options);
}
